// Central API base URL: uses env when provided, falls back to local backend
export const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:5050/api";
